//src/api/general/routes.js
/* Единственное место, где живут НЕплатформенные ручки */

export const ROUTES = {
  me      : '/me',
  coins   : '/get_coins',
  profile : '/get_username',
  role    : '/get-user-role',
  logout  : '/logout',
  refresh : '/refresh',

  // Вложенные секции
  settings: {
    avatars           : '/settings/avatars',
    updateAvatar      : '/settings/update-avatar',           // POST { avatar_id }
    profileVisibility : '/settings/profile_visibility',      // POST { is_profile_hidden }
  },

  apiKey: {
    get      : '/get_api_key',
    generate : '/generate_api_key',
  },

  bugReports: {
    listMine : '/bug_reports/me',
    create   : '/bug_reports',
    item     : (id) => `/bug_reports/${id}`,
    messages : (id) => `/bug_reports/${id}/messages`,
  },
};

// Обратная совместимость: url('profile') → '/get_username'
export const url = (section, action, param) => {
  if (!action && ROUTES[section]) {
    const entry = ROUTES[section];
    return typeof entry === 'function' ? entry(param) : entry;
  }
  const entry = ROUTES?.[section]?.[action];
  if (!entry) throw new Error(`Unknown route ${section}.${action}`);
  return typeof entry === 'function' ? entry(param) : entry;
};
